import { render, staticRenderFns } from "./SendActivationLink.vue?vue&type=template&id=56a43486"
import script from "./SendActivationLink.vue?vue&type=script&lang=js"
export * from "./SendActivationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports